import React from "react";
import classNames from "classnames";
import styles from "./LoyaltyTier.module.scss";

const progressPoints = ["Classic", "Pro", "Expert", "Diamond"];

export const LoyaltyTier = ({
  level,
  cashbackPercent,
  purchaseAmount,
  bonusPaymentPercent = "до 30%",
  benefits = [],
  imageDesktop = "/files/images/bonus-program/tier-1.jpg",
  imageMobile = "/files/images/bonus-program/tier-1-mobile.jpg",
  activePointIndex = 1,
}) => {
  const tierHeaderStatsBoxContent = (
    <div className={styles.tierHeaderStatsBox}>
      <div className={styles.tierHeader}>
        <div className={styles.tierLevel}>
          <p className={styles.tierLabel}>
            Уровень{" "}
            <span className={styles.tierStarBox}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.tierStarIcon}
              >
                <path
                  d="M14 0L19.7615 8.23849L28 14L19.7615 19.7615L14 28L8.23849 19.7615L0 14L8.23849 8.23849L14 0Z"
                  fill="#1A1A1A"
                />
              </svg>
              <span className={styles.tierStarBoxNumber}>
                {activePointIndex}
              </span>
            </span>
          </p>
          <p className={styles.tierLevelName}>{level}</p>
        </div>
        <div className={styles.tierAmount}>
          <span className={styles.tierLabel}>Сумма покупок</span>
          <p className={styles.tierAmountValue}>{purchaseAmount}</p>
        </div>
      </div>

      <div className={styles.tierStats}>
        <div className={styles.tierStatLeft}>
          <span className={styles.tierStatValue}>{cashbackPercent}</span>
          <p className={styles.tierStatLabel}>КЕШБЭК</p>
        </div>
        <div className={styles.tierStatRight}>
          <span className={styles.tierStatValue}>
            {bonusPaymentPercent}
          </span>
          <p className={styles.tierStatLabel}>Оплаты бонусами</p>
        </div>
      </div>
    </div>
  );

  const tierBenefitsContent = (
    <div className={styles.tierBenefits}>
      {benefits.map((benefit, index) => (
        <div key={index} className={styles.tierBenefit}>
          <p>{benefit}</p>
        </div>
      ))}
    </div>
  );

  const tierProgressBarContent = (
    <div className={styles.tierProgressBar}>
      <div className={styles.tierProgressLine}></div>
      <div className={styles.tierProgressPoints}>
        {progressPoints.map((point, index) => {
          const isActive = index === activePointIndex - 1;
          return (
            <div
              key={index}
              className={classNames(styles.tierProgressPoint, {
                [styles.tierProgressPointActive]: isActive,
              })}
            >
              <div className={styles.tierProgressPointDot}></div>
              <span className={styles.tierProgressPointName}>
                {point}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={styles.tierAdaptiveWrap}>
      <div className={styles.tier}>
        <div className={styles.tierImages}>
          <picture>
            <source media="(max-width: 767px)" srcSet={imageMobile} />
            <img
              src={imageDesktop}
              alt={`${level} tier`}
              className={styles.tierImage}
            />
          </picture>
        </div>

        <div className={styles.tierContent}>
          {tierHeaderStatsBoxContent}
          {tierBenefitsContent}
          {tierProgressBarContent}
        </div>
      </div>
      <div className={styles.tierMobileAltContent}>
        {tierHeaderStatsBoxContent}
        {tierBenefitsContent}
        {tierProgressBarContent}
      </div>
    </div>
  );
};
